module.exports = __webpack_public_path__ + "static/logo-4505abdcc599ec63f8c490be0b71746f.png";